var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReset = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.1 16.63a9.32 9.32 0 0 1-16.8 0 .93.93 0 0 1 .85-1.31 1 1 0 0 1 .84.56 7.35 7.35 0 0 0 3.22 3.31A7.47 7.47 0 1 0 6.36 7.34h3.07a1 1 0 0 1 0 1.94H4a.86.86 0 0 1-.23 0 .61.61 0 0 1-.13 0l-.1-.07a.7.7 0 0 1-.2-.21.75.75 0 0 1-.07-.12 1.22 1.22 0 0 1-.12-.19.85.85 0 0 1 0-.22.7.7 0 0 1 0-.14L3 3a1 1 0 0 1 .93-1 1 1 0 0 1 .93 1l.08 3A9.34 9.34 0 0 1 16 4.27a9.45 9.45 0 0 1 4.1 12.36z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 .03h24v24H0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reset.45839678b0d542555802ffa8df82bb4a.svg";